document.addEventListener('DOMContentLoaded', () => {

    const items = document.querySelectorAll('.faq-v1__item');

    items.forEach(item => {

        item.addEventListener('toggle', () => {

            if (!item.open) return;

            items.forEach(other => {

                if (other !== item) {
                    other.removeAttribute('open');
                }

            });

        });

    });

});